import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { WidgetModel } from "../models/widget/widget.model";
import { Observable } from "rxjs";
import { Configuration } from "src/assets/Configuration";
import { WidgetCreationAndUpdateModel } from "../models/widget/widget-creation-and-update.model";

@Injectable({
    providedIn: 'root'
})
export class WidgetService {

    constructor(private httpClient: HttpClient) {
    }

    public getAllWidgets(): Observable<WidgetModel[]> {
        return this.httpClient.get<WidgetModel[]>(Configuration.getApiBaseUrl() + "/widget/all");
    }

    public getDefaultWidgets(): Observable<WidgetModel[]> {
        return this.httpClient.get<WidgetModel[]>(Configuration.getApiBaseUrl() + "/widget/default");
    }

    public getPersonWidgets(): Observable<WidgetModel[]> {
        return this.httpClient.get<WidgetModel[]>(Configuration.getApiBaseUrl() + "/widget/person");
    }

    public updatePersonWidgets(model: WidgetCreationAndUpdateModel): Observable<WidgetModel[]> {
        return this.httpClient.put<WidgetModel[]>(Configuration.getApiBaseUrl() + "/widget/", model);
    }
}